<template>
  <div class="fill">
    <div v-if="hasBgBlur && haSingleImg" class="bannerHeight">
      <img class="bImg" :src="imagem" />
      <div class="fill bAbsolute d-flex justify-center">
        <img class="bannerHeight" height="500px" :src="imagem" />
      </div>
    </div>

    <div v-if="hasBgBlur && !haSingleImg" class="bannerHeight">
      <v-carousel :show-arrows="this._.size(galeria) == 1 ? false : true" :hide-delimiters="this._.size(galeria) == 1 ? true : false" :hide-delimiter-background="this._.size(galeria) == 1 ? true : false" cycle height="500" show-arrows-on-hover>
        <v-carousel-item v-for="(img, i) in galeria" :key="i">
          <img class="bImg" :src="img" />
          <div class="fill bCarousel d-flex justify-center">
            <img height="500px" :src="img" />
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>

    <div v-if="hasText && haSingleImg && !hasPosition" class="bannerHeight">
      <v-img height="500" :src="imagem">
        <div class="darkFilter d-flex flex-column align-center justify-center">
          <img class="mb-5" v-if="hasLogo" height="100" :src="logo" />
          <div class="white--text text-center display-2">{{text}}</div>
        </div>
      </v-img>
    </div>

    <div v-if="hasText && haSingleImg && hasPosition" class="bannerHeight">
      <v-img height="500" position="100% 80%" :src="imagem">
        <div class="darkFilter d-flex flex-column align-center justify-center">
          <img class="mb-5" v-if="hasLogo" height="100" :src="logo" />
          <div class="white--text text-center display-2">{{text}}</div>
        </div>
      </v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentBanner",
  props: [
    "hasBgBlur",
    "hasText",
    "hasLogo",
    "hasPosition",
    "haSingleImg",
    "imagem",
    "galeria",
    "text",
    "logo"
  ],
  methods: {},
  async mounted() {}
};
</script>
